import React from 'react';

import { Container } from './styles';

interface MainColumnProps {
    children?: React.ReactNode;
    isGaMigration?: boolean;
}

export const MainColumn: React.FC<MainColumnProps> = ({ children, isGaMigration }) => {
    return <Container $isGaMigration={isGaMigration}>{children}</Container>;
};
